import { useState } from "react";

export function FinancingCard({ data, itemsPerPage = 3 }) {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <section className="card opacity-40 w-full">
      <h2 className="text-xl font-semibold mb-4">Financing</h2>
      <div className="space-y-2">
        {paginatedData.map((item, index) => (
          <div key={index} className="flex justify-between text-sm">
            <span className="text-gray-700">{item.name}</span>
            <span className="text-green-600 font-semibold">{item.amount}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center mt-4 space-x-2">
        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
          className="p-1 text-gray-600 disabled:text-gray-300"
        >
          &#8249;
        </button>
        {[...Array(totalPages)].map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentPage(idx + 1)}
            className={`w-6 h-6 rounded-full text-sm flex items-center justify-center ${
              currentPage === idx + 1
                ? "bg-blue-900 text-white"
                : "text-gray-600"
            }`}
          >
            {idx + 1}
          </button>
        ))}
        <button
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="p-1 text-gray-600 disabled:text-gray-300"
        >
          &#8250;
        </button>
      </div>
    </section>
  );
}
